<template>
  <!-- <AddButton @click="IsCreate()" v-if="showButton" :btnname=" $t('btn.plusaddnew')"></AddButton>
    <EditIcon @click="IsEdit()" v-if="!showButton" /> -->
  <Dialog
    :modal="true"
    v-model:visible="showDialog"
    :header="
      model ? $t('stores.Room.EditFormHeader') : $t('stores.Room.FormHeader')
    "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="8" lg="8" md="8" cols="12">
          <div class="field">
            <TextField
              v-model="dataModel.Name"
              type="text"
              placeholder=" "
              clearable
              name="Room Name"
              :label="$t('room.name')"
              :rules="{ required: true }"
              id="Room Name"
              :required-icon="true"
              case="Capital"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" lg="8" md="8" cols="12">
          <StoreDropDown
            :label="$t('room.Mapping')"
            name="Store Mapping"
            id="Store Mapping"
            v-model="selectOption.StoreId"
            @update:modelValue="SelectStore(selectOption.StoreId)"
            :rules="{ required: true }"
            :required-icon="true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="(showDialog = false), IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloader"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, PropType, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
import commonservice from "../../../../Service/RoomService";
import storeService from "../../../../Service/StoreService";

import { value } from "dom7";

import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import StoreDropDown from "../../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    CustomDropDown,

    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    StoreDropDown,
  },
  setup(props, { emit }) {
    // LoadStore();
    const { t } = useI18n();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const label = ref(t("btn.save"));
    let loading = ref(false);
    let Saveloader = ref(false);
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref();
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const dataModel = ref({
      Id: 0,
      Name: "",
      StoreId: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      StoreBrMapId: 0,
    });
    const copydataModel = JSON.parse(JSON.stringify(dataModel.value));
    debugger;
    const selectOption = ref({
      StoreId: ref(),
      storeOption: [],
    });
    const copyselectOption = JSON.parse(JSON.stringify(selectOption.value));
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    //Store  Select Load function
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    function SelectStore(value) {
      debugger;
      if (value) {
        let store: any = selectOption.value.StoreId.Id;
        dataModel.value.StoreId = Number(store);
        dataModel.value.StoreBrMapId =
          selectOption.value.StoreId.StoreBranchMapId;
        dataModel.value.BranchId = selectOption.value.StoreId.BranchId;
      }
    }
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      }
      // else if (event.altKey && event.key == 'n') {
      //     showDialog.value = true;
      // }
      else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    function IsCreate() {
      showDialog.value = true;
    }
    //Store Change
    function storeChange(value: string) {
      dataModel.value.StoreId = parseInt(value);
    }
    //Insert Update Room
    const IsSubmit = async () => {
      // emit("loadershow");
      debugger;
      Saveloader.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloader.value = false;
        return;
      }

      console.log(dataModel.value.StoreId);
      dataModel.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      dataModel.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");

      dataModel.value.HospitalId = HospitalId;
      dataModel.value.EntityId = Number(Entitydata.value.EntityId);
      try {
        let result: any;
        let msg = "";
        if (dataModel.value.Id != 0) {
          dataModel.value.EntityOperationId = props.OperationID.UpdateId;
          dataModel.value.ModifiedBy = UserId;
          result = await commonservice.updateRoom(dataModel.value);
          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloader.value = false;
            updatepop.value = true;
          } else {
            Saveloader.value = false;
            alert("something went wrong");
          }
        } else {
          dataModel.value.EntityOperationId = props.OperationID.CreateId;
          dataModel.value.CreatedBy = UserId;
          result = await commonservice.insertRoom(dataModel.value);
          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloader.value = false;
            successpop.value = true;
          } else {
            Saveloader.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        loading.value = false;
        Saveloader.value = false;
      }
    };

    //Edit Room
    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");
      debugger;
      try {
        //dataModel.value.Id = model.value.Id;
        label.value = t("btn.update");
        const result = await commonservice.getRoomById(model.value.Id);
        let resfields = result["result"];
        Object.keys(dataModel.value).forEach((key) => {
          if (resfields[key]) dataModel.value[key] = resfields[key];
        });
        // selectOption.value.StoreId = resfields.StoreId;
        selectOption.value.StoreId = resfields.StoreBrMapId;
        dataModel.value.StoreId = resfields.StoreId;
        dataModel.value.CreatedAt = "2023-02-03T11:05:31.945Z";
        dataModel.value.StoreBrMapId = resfields.StoreBrMapId;
        emit("loaderhide");
      } catch (error) {
        emit("loaderhide");
      }
    }
    //Clear
    function IsClear() {
      Object.assign(dataModel.value, copydataModel);
      Object.assign(selectOption.value, copyselectOption);
      // LoadStore();
      showDialog.value = false;
      //emit("update:trigger", false);
      emit("update:selectedItem", undefined);
      emit("close");
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      dataModel.value.Name = "";
      //showDialog.value = true
    }
    return {
      Saveloader,
      IsClear,
      IsEdit,
      IsSubmit,
      storeChange,
      dataModel,
      selectOption,
      handleValidateButtonClick() {
        emit("clicked");
      },
      onlyAllowNumber: (value: string) => !value || /^\d+$/.test(value),
      showModal: ref(false),
      IsCreate,
      showDialog,

      errors,
      successpop,
      updatepop,
      closetrigger,
      alreadyclosetrigger,
      alreadyexistpop,
      label,
      loading,
      model,
      SelectStore,
    };
  },

  methods: {},
});
</script>
